import * as React from 'react'

/**
 * @description Metro icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Metro } from '@sravni/design-system-icons'
 *
 * <Metro />
 * ```
 */
export const Metro = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Metro" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#Metro__a)">
      <path
        d="M10 16.309 6.526 9.63l-1.884 6.459H2L5.841 3 10 11.049 14.159 3 18 16.089h-2.642L13.474 9.63 10 16.309Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="Metro__a">
        <path fill="currentColor" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
))
